const props = {};
let container = null;
let current = null;
let nextButton = null;
let previousButton = null;
let pagerItems = null;
let numberOfSlides = null;
let navigation = null;
let timer = null;

export const init = params => {
  // Exists if container doesn't exists
  if (!params.container) return;
  ({ container } = params);
  current = params.index || 0;
  props.autoplay = params.autoplay || false;
  props.interval = params.interval || 5000;

  // Remove --first class on first slide (opacity & animation purpose)
  const firstSlide = cube.$('.dkt-home-slider__slide--first');
  if (firstSlide) firstSlide.classList.remove('dkt-home-slider__slide--first');

  numberOfSlides = (cube.$$('.dkt-home-slider__slide') || []).length;

  navigationInit();
};

const navigationInit = () => {
  navigation = container.querySelector('.dkt-home-slider-navigation');
  let items = '';

  for (let i = 0; i < numberOfSlides; i += 1) {
    items += `<li class="dkt-slider-pager-item"><button data-tnr-hp-banner-selector-${i} data-index="${i}">${i}</button></li>`;
  }

  navigation.innerHTML =
    `${'<button class="dkt-slider-button dkt-slider-button--previous">Previous</button>' +
      '<ul class="dkt-slider-pager">'}${items}</ul>` +
    `<button class="dkt-slider-button dkt-slider-button--next">Next</button>`;

  nextButton = container.querySelector('.dkt-slider-button--next');
  previousButton = container.querySelector('.dkt-slider-button--previous');
  pagerItems = container.querySelectorAll('.dkt-slider-pager-item');

  navigationRefresh();
  bindEvents();
  if (props.autoplay === true) {
    launchAutoPlay();
  }
};

const launchAutoPlay = () => {
  timer = setInterval(() => {
    if (current + 2 <= numberOfSlides) current += 1;
    else current = 0;

    moveSlider();
  }, props.interval);
};

const navigationRefresh = () => {
  if (numberOfSlides <= 1)
    navigation.classList.add('dkt-home-slider-navigation--hidden');
  else navigation.classList.remove('dkt-home-slider-navigation--hidden');

  previousButton.disabled = current === 0;
  nextButton.disabled = current + 1 >= numberOfSlides;

  for (let i = 0; i < pagerItems.length; i += 1) {
    if (i >= current && i < current + 1) {
      pagerItems[i].classList.add('dkt-slider-pager-item--current');
    } else {
      pagerItems[i].classList.remove('dkt-slider-pager-item--current');
    }
    pagerItems[i].querySelector('button').disabled =
      i >= current && i < current + 1;
  }
};

const bindEvents = () => {
  nextButton.addEventListener('click', () => {
    current += 1;
    moveSlider(true);
  });

  previousButton.addEventListener('click', () => {
    current -= 1;
    moveSlider(true);
  });

  [...pagerItems].forEach(item => {
    item.querySelector('button').addEventListener('click', () => {
      current = Number(item.querySelector('button').getAttribute('data-index'));
      moveSlider(true);
    });
  });
};

const moveSlider = clearTimer => {
  if (clearTimer === true) {
    clearInterval(timer);
    cube.event.send('slider-hp-opeco', current);
  }
  const slides = container.querySelectorAll('.dkt-home-slider__slide');

  [].forEach.call(slides, (slide, index) => {
    if (index === current)
      slide.classList.add('dkt-home-slider__slide--current');
    else slide.classList.remove('dkt-home-slider__slide--current');
  });

  navigationRefresh();
};



// WEBPACK FOOTER //
// ./src/homepage/sliders/home-slider-opeco.js